import { useMemo, useState } from "react";
import {
  TextField,
  DatagridConfigurable,
  DateField,
  NumberField,
  useTheme,
  usePermissions,
  FunctionField,
  RecordContextProvider,
} from "react-admin";
import getFirstAndLastDateOfCurrentMonth from "../../utils/firstLastDate";
import DownloadAction from "../../components/tableListActions/DownloadActionNew";
import SaleNetCardExpandList from "../../components/saleNetCards/expand/SaleNetCardExpandList";
import SaleReturnCardList from "../saleReturnCards/SaleReturnCardList";
import saleNetCardFilterList from "../../components/saleNetCards/filter/saleNetCardFilterList";
import ManualReportList from "../../components/reports/ManualReportList";
import useCompanyScopedListFilters from "../../hooks/useCompanyScopedListFilters";

const [firstDate, lastDate] = getFirstAndLastDateOfCurrentMonth();

const SaleNetCardList = (props) => {
  const { permissions } = usePermissions();
  const [theme] = useTheme("light");
  const [appliedParentFilter, setAppliedParentFilter] = useState(null);
  const { filterDefaultValues } = useCompanyScopedListFilters({
    start_date: firstDate,
    end_date: lastDate,
    approved: 1,
  });

  const list = useMemo(() => {
    return (
      <>
        <ManualReportList
          storeKey={false}
          title={props.title ? props.title : undefined}
          empty={false}
          actions={<DownloadAction />}
          filters={saleNetCardFilterList(permissions)}
          filter={{
            approved: 1,
          }}
          filterDefaultValues={filterDefaultValues}
          requiredFilters={["start_date", "end_date"]}
          onApplied={setAppliedParentFilter}
          onReset={() => setAppliedParentFilter(null)}
          queryOptions={{ meta: { sort: ["created_at DESC"] } }} // overide default sort
          sx={{
            flexDirection: "column",
          }}
        >
          <DatagridConfigurable
            bulkActionButtons={false}
            expand={<SaleNetCardExpandList />}
            sx={{
              "& .RaDatagrid-expandedPanel > td": {
                p: 0,
                bgcolor: theme !== "dark" ? "#E7EBF0" : "grey.800",
              },
            }}
          >
            <TextField label="mine.label.depo" source="company.alias" />
            <TextField source="code" label="mine.label.receipt_no" />
            <FunctionField
              label="mine.label.order_no"
              render={(record) =>
                record.sale_items[0].sale_order_item.sale_order.code
              }
            />
            <DateField
              source="date"
              label="mine.label.date"
              options={{
                year: "numeric",
                month: "short",
                day: "2-digit",
              }}
            />
            <TextField
              source="sale_items[0].sale_order_item.sale_order.customer.name"
              label="mine.label.customer"
              emptyText="-"
            />
            <TextField
              source="sale_items[0].sale_order_item.sale_order.salesman.name"
              label="Salesman"
              emptyText="-"
            />
            <FunctionField
              label="Transport"
              render={(record) => `${record.transport.code}`}
            />
            <TextField
              source="promotion.name"
              label="mine.label.promotion"
              emptyText="-"
            />
            <FunctionField
              textAlign="right"
              label="Box"
              render={(record) => {
                let rec = { total_sent: 0 };
                for (let i = 0; i < record.sale_items.length; i++) {
                  rec.total_sent += +record.sale_items[i].sent_quantity;
                }
                return (
                  <RecordContextProvider value={rec}>
                    <NumberField source="total_sent" />
                  </RecordContextProvider>
                );
              }}
            />
            <NumberField source="total" label="mine.label.value" />
            <TextField source="note" label="mine.label.note" emptyText="-" />
          </DatagridConfigurable>
        </ManualReportList>
        <div style={{ margin: "22px 0 8px 0" }} /> {/* ================ */}
        {appliedParentFilter ? <SaleReturnCardList
          withActions={false}
          withFilters={false}
          disableSyncWithLocation={true}
          grandTotalResource="sale-net-cards"
          title=" "
          parentFilter={appliedParentFilter}
        /> : null}
      </>
    );
  }, [
    theme,
    permissions,
    props.title,
    appliedParentFilter,
    filterDefaultValues,
  ]);
  return list;
};

export default SaleNetCardList;
